import * as page from "../../../../../src/ssg/hs/frentagonist/index.ts";

if (typeof page["onload"] === "function") {
	page["onload"]();
}